export { EmailQuoteModal } from './email-quote-modal.component';
export { EmailQuoteModule } from './email-quote.module';
export { EmailQuoteData } from './models/email-quote-data.model';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/email-quote/index.ts